import styled, { css } from "styled-components"
import Img from "gatsby-image"
import {
  desktopTextStyles,
  tabletTextStyles,
  mobileTextStyles,
} from "../shared/typography.styles"
import Breakpoints from "../shared/breakpoints"

export const ContentBackground = styled.div`
  background-color: var(--tricorn-black);
  width: 100vw;
`

export const Title = styled.h1`
  grid-row: 1;
  margin-top: 64px;
  ${mobileTextStyles.MobileHeadingOneRegular}
  color: var(--white);
  grid-column: 2 / -2;
  text-align: center;
  padding-bottom: 24px;
  border-bottom: 1px solid #f2f2f266;
  grid-row: 1;

  @media (min-width: ${Breakpoints.md}) {
    ${tabletTextStyles.TabletHeadingOneRegular}
    grid-column: 1 / -1;
  }

  @media (min-width: ${Breakpoints.lg}) {
    ${desktopTextStyles.HeadingOneRegular}
    grid-column: 3 / -3;
  }
`

export const FadedTitleWrapper = styled.div`
  display: grid;
  justify-self: center;
  grid-column: 2 / 12;
  grid-row: 1;
  margin-top: 48px;

  & h3 {
    color: var(--dark-mode-body-grey);
  }
  
  @media(min-width: ${Breakpoints.md}) {
    margin-top: 128px;
  }

  @media (min-width: ${Breakpoints.lg}) {
    grid-column: 1 / -1;
    margin-top: 128px;
  }
`

export const StyledFluid = styled(Img)`
  grid-column: 1 / -1;
  @media (min-width: ${Breakpoints.md}) {
    grid-column: 3 / -3;
  }
  width: 100%;
  ${props => props.styleModifier}
`
export const draftPubImageStyle = css`
  grid-row: 2;
  margin-top: 48px;
  box-shadow: none;
  @media (min-with: ${Breakpoints.md}) {
    margin-top: 64px;
    grid-column: 3 / -3;
  }
  @media (min-width: ${Breakpoints.lg}) {
    margin-top: 120px;
    grid-column: 8 / -1;
  }
`

export const previewMapImageStyle = css`
  grid-row: 4;
  margin-top: 64px;
  @media (min-with: ${Breakpoints.md}) {
    grid-column: 3 / -3;
    margin-top: 112px;
  }
  @media (min-width: ${Breakpoints.lg}) {
    margin-top: 128px;
    grid-row: 3;
    grid-column: 1 / 7;
  }
`

export const manageEventsImageStyle = css`
  grid-row: 6;
  margin-top: 64px;
  border-radius: 13px;
  @media (min-width: ${Breakpoints.md}) {
    grid-column: 4 / -4;
    margin-top: 96px;
  }
  @media (min-width: ${Breakpoints.lg}) {
    margin-top: 128px;
    grid-row: 4;
    grid-column: 8 / -1;
    margin-bottom: 96px;
  }
`

export const DetailsWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  text-align: center;
  align-self: center;
  align-items: center;

  @media (min-width: ${Breakpoints.lg}) {
    text-align: left;
    align-items: flex-start;
  }

  ${props => props.styleModifier}
`
export const draftPubStyle = css`
  grid-column: 1 / -1;
  grid-row: 3;

  @media (min-width: ${Breakpoints.md}) {
    grid-column: 2 / -2;
  }

  @media (min-width: ${Breakpoints.lg}) {
    grid-column: 2 / 7;
    grid-row: 2;
  }
`

export const previewMapsStyle = css`
  grid-column: 1 / -1;
  grid-row: 5;

  @media (min-width: ${Breakpoints.md}) {
    grid-column: 2 / -2;
  }

  @media (min-width: ${Breakpoints.lg}) {
    grid-column: 8 / -2;
    grid-row: 3;
  }
`

export const manageEventsStyle = css`
  grid-column: 1 / -1;
  grid-row: 7;
  margin-bottom: 64px;

  @media (min-width: ${Breakpoints.md}) {
    grid-column: 2 / -2;
    margin-bottom: 48px;
  }

  @media (min-width: ${Breakpoints.lg}) {
    grid-column: 2 / 6;
    grid-row: 4;
    margin-bottom: 0px;
  }
`

export const DetailsBody = styled.p`
  color: var(--dark-mode-body-grey);
  margin-top: 24px;
  ${mobileTextStyles.MobileBodyRegular}

  @media (min-width: ${Breakpoints.md}) {
    ${tabletTextStyles.TabletBodyRegular}
  }

  @media (min-width: ${Breakpoints.lg}) {
    margin-top: 16px;
    ${desktopTextStyles.BodyText18}
  }
`

export const DetailsTitle = styled.h3`
  color: var(--dark-mode-body-grey);
  margin-top: 32px;
  ${mobileTextStyles.MobileHeadingThreeBold}

  @media (min-width: ${Breakpoints.md}) {
    ${tabletTextStyles.TabletHeadingThreeBold}
  }

  @media(min-width: ${Breakpoints.lg}) {
    ${desktopTextStyles.HeadingThreeBold}
  }
`

export const linkStyle = css`
  width: 100%;
  margin-top: 32px;
  max-width: 282px;

  @media (min-width: ${Breakpoints.md}) {
    max-width: 336px;
  }

  @media (min-width: ${Breakpoints.lg}) {
    margin-top: 48px;
    max-width: 336px;
    justify-self: left;
  }
`
